module.exports = __webpack_public_path__ + "static/bbis-catering-min-a7117c1966dd639cd907d677a24cafef.jpg";